// 转换时间格式为年月日
// 转换年月日方法
export function getDate(format, str) {
  str = Number(str)
  var oDate = new Date(str)
  var oYear = oDate.getFullYear()
  var oMonth = oDate.getMonth() + 1
  var oDay = oDate.getDate()
  var oHour = oDate.getHours()
  var oMin = oDate.getMinutes()
  var oSec = oDate.getSeconds()
  var oTime
  if (format === 'yyyy-mm-dd') {
    oTime =
      oYear +
      '-' +
      getzf(oMonth) +
      '-' +
      getzf(oDay) +
      ' ' +
      getzf(oHour) +
      ':' +
      getzf(oMin) +
      ':' +
      getzf(oSec) // 最后拼接时间
  } else if (format === 'yyyy/mm/dd') {
    oTime =
      oYear +
      '/' +
      getzf(oMonth) +
      '/' +
      getzf(oDay) +
      ' ' +
      getzf(oHour) +
      ':' +
      getzf(oMin) +
      ':' +
      getzf(oSec) // 最后拼接时间
  }
  return oTime
  function getzf(num) {
    if (parseInt(num) < 10) {
      num = '0' + num
    }
    return num
  }
}
